import Immutable from 'immutable';
import Cookies from 'cookies-js';

import { WATCHLIST_NAME as OVERVIEW_CHART_WATCHLIST_NAME } from 'components/Overview/OverviewChart';

import * as ActionTypes from 'constants/ActionTypes';

const initialState = Immutable.fromJS({
  didInvalidate: true,
  isFetching: false,
  watchlists: [],
  selected: Cookies.get('selectedWatchlist'),
  prevSelected: null,
});

export default function watchlists(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.INVALIDATE_WATCHLISTS:
      return state.set('didInvalidate', true);

    case ActionTypes.REQUEST_WATCHLISTS:
      return state.set('isFetching', true);

    case ActionTypes.RECEIVE_WATCHLISTS:
      let converted;

      if (Array.isArray(action.data)) {
        converted = Immutable.fromJS(action.data)
          .filter(list => list !== OVERVIEW_CHART_WATCHLIST_NAME)
          .toKeyedSeq()
          .mapEntries(kv => [kv[1], null]);
      } else {
        converted = Immutable.fromJS(action.data)
          .filter((_, list) => list !== OVERVIEW_CHART_WATCHLIST_NAME)
          .toMap();
      }
      return state.merge(
        Immutable.fromJS({
          didInvalidate: false,
          watchlists: converted.toJS(),
          isFetching: false,
        }),
      );

    case ActionTypes.SET_SELECTED_WATCHLIST:
      return state.merge(
        Immutable.fromJS({
          selected: action.name,
          prevSelected: state.get('selected'),
        }),
      );

    case ActionTypes.WATCHLIST_ADD_ITEM:
    case ActionTypes.WATCHLIST_DELETE_ITEM:
    case ActionTypes.WATCHLIST_ADD_LIST:
      return state.updateIn(['watchlists'], lists => {
        return lists.set(action.name, null);
      });

    case ActionTypes.WATCHLIST_DELETE_LIST:
      return state.updateIn(['watchlists'], lists => {
        return lists.filterNot((_, list) => list === action.name);
      });

    case ActionTypes.WATCHLIST_UPDATE_LIST:
    default:
      return state;
  }
}
